import {registry} from '../modules/registry';
import {attachModuleToEl} from './attach-module-to-el';

export function readSpecAndInitModule(el, moduleSpec) {
    let moduleFound = false;

    const moduleNameParts = moduleSpec.obj.split('.');
    moduleNameParts.length > 1 && (moduleNameParts[1] = moduleSpec.obj);
    moduleNameParts
        .filter((moduleNamePart) => registry.contains(moduleNamePart))
        .forEach((moduleNamePart) => {
            if (moduleSpec.option) {
                moduleSpec.option.nameSpace = moduleNamePart;
            }

            attachModuleToEl(moduleNamePart, el, moduleSpec.option);
            moduleFound = true;
        });

    return moduleFound;
}
